import React, {useState} from 'react'
import {Tooltip} from 'antd'

import {StorageIcon, TruckIcon} from 'components/CustomIcons'
import BButton from 'components/Form/Fields/BButton'
import Counter from 'components/Cart/Counter'
import priceParser from 'utils/priceParser'

const StoresListItem = ({store, t}) => {
  const [amount, setAmount] = useState(1)

  const basket = () => {
    alert('WiP add to basket items: ' + amount)
  }

  return (
    <li>
      <div>
        <div>
          <div style={{backgroundImage: 'url(' + store?.logo_url + ')'}}/>
          <div>
            <Tooltip title={t('Some more info about the delivery maybe? WiP placeholder')}>                 {/* TODO */}
              <TruckIcon/>
              <div>
                <span>Buildiro direct</span>
                <span>(delivery from {priceParser(42.42)})</span>
              </div>
            </Tooltip>
          </div>
          <div>
            <StorageIcon/> in stock
          </div>
        </div>
        <div>
          <span>{priceParser(4242.42)}</span>
          <Counter amount={amount} setAmount={setAmount}/>
          <BButton yellow onClick={basket}>{t('ADD TO BASKET')}</BButton>
        </div>
      </div>
    </li>
  )
}

export default StoresListItem
